<div
  class="attribute-editor-component video-streaming-container"
  rvSpinner="video-streaming-editor-loader"
  [rvShowSpinner]="spinner"
>
  <div class="attribute-editor-row" [style.marginBottom]="'24px'">
    Supports HLS (HTTP Live Streaming) protocol. Videos won't be shown in
    preview but will play on your Display.
  </div>
  <div class="attribute-editor-row">
    <form>
      <div
        class="form-group has-feedback"
        [ngClass]="{
          'has-error': sourceStatus && sourceStatus !== 'VALID',
          'has-success': sourceStatus === 'VALID' && source !== '',
        }"
      >
        <label class="control-label" for="te-video-streaming-src"
          >Source:</label
        >
        <input
          type="text"
          id="te-video-streaming-src"
          name="te-video-streaming-src"
          class="form-control u_ellipsis"
          placeholder="Enter URL"
          [(ngModel)]="source"
          (debounceEvent)="saveSource()"
          (keyup)="sourceStatus = null"
          aria-label="HLS video streaming source URL"
          maxlength="2048"
          [attr.aria-invalid]="sourceStatus && sourceStatus !== 'VALID'"
        />
        <streamline-icon
          *ngIf="sourceStatus"
          class="overlay-icon form-control-feedback"
          aria-hidden="true"
          [name]="sourceStatus !== 'VALID' ? 'exclamation' : 'checkmark'"
          width="14"
          height="12"
        ></streamline-icon>
        <p class="help-block">
          @switch (sourceStatus) {
            @case ('INVALID') {
              <span>Please provide a valid HLS URL.</span>
            }
            @case ('VIDEO_NOT_FOUND') {
              <span>Video streaming not found.</span>
            }
            @case ('NOT_SUPPORTED') {
              <span
                >Your browser doesn't support HLS. Please, configure your video
                streaming on a modern browser.</span
              >
            }
          }
        </p>
      </div>
    </form>
  </div>

  <div class="attribute-editor-row">
    <div id="video-streaming-component-volume">
      <label [style.marginBottom]="0" class="control-label">Volume:</label>
      <div class="w-100 flex flex-row gap-3">
        <mat-icon svgIcon="volume" class="mr-1 large"></mat-icon>
        <mat-slider
          min="0"
          max="100"
          step="1"
          color="accent"
          aria-label="Video volume control"
          class="flex-grow"
        >
          <input
            matSliderThumb
            [(ngModel)]="volume"
            (valueChange)="saveVolume()"
            [attr.aria-valuetext]="volume + ' percent volume'"
          />
        </mat-slider>
        <div class="volume">{{ volume }}</div>
      </div>
    </div>
  </div>

  <div class="attribute-editor-row">
    <div class="form-group">
      <label
        id="te-video-audio-label"
        class="control-label"
        for="te-video-audio"
        >Audio:</label
      >
      <mat-form-field
        appearance="outline"
        subscriptSizing="dynamic"
        class="tw-w-full"
      >
        <mat-select
          id="te-video-audio"
          [ngModel]="selectedAudioTrackIndex()"
          aria-labelledby="te-video-audio-label"
          (ngModelChange)="saveAudioTrack($event)"
          [disabled]="!audioTracks()?.length"
          canSelectNullableOptions
        >
          <mat-option [value]="null">Default</mat-option>
          @for (audioTrack of audioTracks(); track audioTrack) {
            <mat-option [value]="audioTrack.index">
              {{ audioTrack.name }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
  </div>

  <div class="attribute-editor-row">
    <div class="form-group">
      <label
        id="te-video-subtitles-label"
        class="control-label"
        for="te-video-subtitles"
        >Subtitles:</label
      >
      <mat-form-field
        appearance="outline"
        subscriptSizing="dynamic"
        class="tw-w-full"
      >
        <mat-select
          id="te-video-subtitles"
          [ngModel]="selectedCaptionTrackIndex()"
          aria-labelledby="te-video-subtitles-label"
          (ngModelChange)="saveCaptionTrack($event)"
          [disabled]="!captionTracks()?.length"
          canSelectNullableOptions
        >
          <mat-option [value]="null">
            {{ captionTracks()?.length ? 'Off' : 'Not available' }}
          </mat-option>
          @for (captionTrack of captionTracks(); track captionTrack) {
            <mat-option [value]="captionTrack.index">
              {{ captionTrack.name }}
              @if (captionTrack.type === 'captions') {
                [cc]
              }
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
  </div>

  <div class="attribute-editor-row">
    <div class="flex-row left-right-aligner pt-3">
      <label
        id="video-streaming-center-subtitles-label"
        class="mb-0 control-label"
        >Center Subtitles:</label
      >
      <mat-slide-toggle
        class="pl-3"
        [checked]="centerSubtitles"
        (change)="centerSubtitlesChanged($event.checked)"
        [attr.aria-labelledby]="'video-streaming-center-subtitles-label'"
      ></mat-slide-toggle>
    </div>
  </div>

  <div class="attribute-editor-row" id="videoContainer" [hidden]="true"></div>
</div>
